module.exports = __webpack_public_path__ + "media/images/pic/anime/bread-0b5e64fbcb52d6cd7aaa52e428d881c0.svg";